import { useState } from 'react';
import axios from 'axios';
import { useAppSelector } from 'src/services/redux/app/Store';
import { IAnswerTemplate, IAnswerTemplateBody } from '../interfaces';

const VENDOR_MC_URL = `${process.env.REACT_APP_API_PIM_URL}`;

export const useAnswerTemplate = () => {
  const [answers, setAnswers] = useState<IAnswerTemplate[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<any>(null);
  const { user } = useAppSelector((state) => state.auth);

  const getAnswerTemplateList = async () => {
    setLoading(true);
    try {
      const res = await axios.get<IAnswerTemplate[]>(`${VENDOR_MC_URL}/product-answer-template/${user?.vendor.id}/list`);
      setAnswers(res.data);
    } catch (error: any) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };



  const addAnswerTemplate = async (body: IAnswerTemplateBody) => {
    setLoading(true);
    try {
      var request = {
        answerBody: body.answerBody,
        answerTitle: body.answerTitle,
      };
      await axios.post(`${VENDOR_MC_URL}/product-answer-template/${user?.vendor.id}/add`, request);
      await getAnswerTemplateList();
    } catch (error: any) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const editAnswerTemplate = async (id: number, body: IAnswerTemplateBody) => {
    setLoading(true);
    try {
      var request = {
        answerBody: body.answerBody,
        answerTitle: body.answerTitle,
      };
      await axios.post(`${VENDOR_MC_URL}/product-answer-template/${user?.vendor.id}/${id}/edit`, request);
    } catch (error: any) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const deleteAnswerTemplate = async (id: number) => {
    setLoading(true);
    try {
      await axios.get(`${VENDOR_MC_URL}/product-answer-template/${user?.vendor.id}/${id}/delete`);
    } catch (error: any) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return { answers, deleteAnswerTemplate, getAnswerTemplateList, loading, error, setError, addAnswerTemplate, editAnswerTemplate };
};
